require('./error-report.css');
require('./jquery.popline.js');
require('./selection-polyfill.js');
require('pgwbrowser');
require('./jquery.blockUI-2.70.0.js');
require('./jquery.maxlength-short.js');
var checkFields = require('./checkfields.js');

function generateUniqString() {
	// функция для генерации уникальной в пределах документа строки
	var alphabet = 'abcdefghijklmnopqrstuvwxyz0123456789';
	var result = '';
	for (var i = 0; i < 10; i++) {
		result += alphabet.charAt(Math.floor(alphabet.length * Math.random()));
	}
	if ($('html').html().toString().indexOf(result) === -1) {
		return result;
	} else {
		return generateUniqString();
	}
}

function fixChildNodesCount(node, index) {
	// костыль для IE8: для дочерней подноды node.childNodes[index] вычисляет, сколько предыдущих поднод было пропущено и возвращает их число
	var difference = 0;
	for (var i = index; i > 0; i--) {
		if (node.childNodes[i].nodeType == 1 && node.childNodes[i - 1] && node.childNodes[i - 1] instanceof HTMLBRElement) {
			difference++;
		}
	}
	return difference;
}

function scrollToPos(offset) {
	$('html')
		.velocity('scroll', {
			offset: offset + 'px',
			duration: 500,
			mobileHA: false
		});
	return true;
}

function checkPlugin(pluginName, pluginFileName) {
	var s = '<p>Не найден или не подключен плагин ' + pluginName + '. В базовом репозитарии плагин находится по адресу "/local/templates/mainframe/scripts/' + pluginFileName + '"</p>';

	return s;
}

var handleInput = function (el) {
	if (el.val() != '') {
		el.addClass('edited');
	} else {
		el.removeClass('edited');
	}
};

$(window).on('load', function () {
	// при загрузке странцы проверяем, есть ли хеш ЗО
	$(window).trigger('hashchange');
});

$(document).ready(function () {
	var error = 0;
	var errorBlock	= $('.popup-error-block#template');
	var checkedForm = $('#comments-form');
	var gid = checkedForm.find('input#gid').val();
	var arLangMess	=
	{
		ru:
		{
			CounterBeginText: ' осталось ',
			CounterEndText: ' символов',
			popupWindow: 'Ваш комментарий успешно отправлен'
		},
		en:
		{
			CounterBeginText: '',
			CounterEndText: ' characters left',
			popupWindow: 'Your comment has been successfully sent'
		},
	};

	if (!$.popline) {
		$(checkPlugin('$.popline', 'jquery.popline.js')).appendTo(errorBlock);
		error++;
	}
	if (!window.IE8SelectionPolyfill) {
		$(checkPlugin('selection-polyfill.js', 'selection-polyfill.js')).appendTo(errorBlock);
		error++;
	}
	if (!$.blockUI) {
		$(checkPlugin('$.blockUI', 'jquery.blockUI-2.70.0.js')).appendTo(errorBlock);
		error++;
	}
	if (!$.pgwBrowser) {
		$(checkPlugin('$.pgwBrowser', 'pgwbrowser.min-1.3.js')).appendTo(errorBlock);
		error++;
	}
	if (!$.fn.maxlength) {
		$(checkPlugin('$.maxlength', 'jquery.maxlength-short.js')).appendTo(errorBlock);
		error++;
	}
	if (window.location.hash.match(/\!(.*?)\!/) !== null && typeof BX === 'undefined') {
		$('<p>Пожалуйста <a href="/bitrix/">авторизуйтесь</a></p>').appendTo(errorBlock);
		errorBlock.fadeIn();
		scrollToPos(errorBlock.offset().top - 10);
		error++;
	}
	if (typeof BX === 'undefined') {
		error++;
	}
	if (error != 0 && gid == 1) {
		errorBlock.fadeIn();
	} else if (error == 0) {
		var browser = {};
		browser.msie	= ($.pgwBrowser().browser.name == 'Internet Explorer' ? true : false);
		browser.name = $.pgwBrowser().browser.name;
		browser.version	= $.pgwBrowser().browser.majorVersion;

		$('form#comments-form #COMMENT_AUTHOR, form#comments-form #COMMENT_TITLE').maxlength(
		{
			maxChars: 255,
			Counter: true,
			CounterClass: 'comments__counter',
			CounterBeginText: arLangMess[BX.message.LANGUAGE_ID].CounterBeginText,
			CounterEndText: arLangMess[BX.message.LANGUAGE_ID].CounterEndText,
			CounterTextColor: '#666',
			errorBorder: '',
			okBorder: ''
		});
		$('form#comments-form #COMMENT_TEXT').maxlength(
		{
			maxChars: 3000,
			Counter: true,
			CounterClass: 'comments__counter',
			CounterBeginText: arLangMess[BX.message.LANGUAGE_ID].CounterBeginText,
			CounterEndText: arLangMess[BX.message.LANGUAGE_ID].CounterEndText,
			CounterTextColor: '#666',
			errorBorder: '',
			okBorder: ''
		});

		if ($('form#comments-form #uid').val() * 1 == 0) {
			$('form#comments-form #captcha_word').maxlength(
			{
				maxChars: 5,
				Counter: true,
				CounterClass: 'comments__counter',
				CounterBeginText: arLangMess[BX.message.LANGUAGE_ID].CounterBeginText,
				CounterEndText: arLangMess[BX.message.LANGUAGE_ID].CounterEndText,
				CounterTextColor: '#666',
				errorBorder: '',
				okBorder: ''
			});
		}

		$('#comments')
			.on('keydown', '.form-control', function (e) {
				handleInput($(this));
			})
			.on('blur', '.form-control', function (e) {
				handleInput($(this));
			})
		;

		checkedForm.on('blur', '[data-require="true"]', function () {
			var arCheckFields	= {};
			var field = $(this);

			arCheckFields[field.attr('id')] =
			{
				type: field.data('type'),
				id: 'form#' + checkedForm.attr('id') + ' #' + field.attr('id'),
				default: (!empty(field.attr('placeholder')) ? field.attr('placeholder') : '')
			};
			if (field.data('type') == 'captcha') {
				arCheckFields[field.attr('id')].word = field.val();
				arCheckFields[field.attr('id')].sid = checkedForm.find('input#captcha_sid').val();
			}

			checkFields(arCheckFields);
		});

		;(function ($) {
			if (typeof BX !== 'undefined' && BX.message.USER_ID !== '') {
				$.popline.addButton(
				{
					search:
					{
						iconClass: 'comments',
						mode: 'view',
						action: function (event) {
							var commentsBlock = $('div#comments');
							var selectedText = $.popline.utils.selection().text();
							var selectedRange = window.getSelection().getRangeAt(0);
							var startId = $(selectedRange.startContainer.parentNode).attr('data-mc-id');
							var endId = $(selectedRange.endContainer.parentNode).attr('data-mc-id');
							if (typeof(startId) === 'undefined' || typeof(endId) === 'undefined') {
								$('<p>Выделенный фрагмент не может быть обработан инструментом «заметил ошибку»</p>').appendTo(errorBlock);
								errorBlock.fadeIn();
								if (errorBlock.length) {
									scrollToPos(errorBlock.offset().top - 10);
								}
								return false;
							}
							if (browser.msie && browser.version < 9) {
								// используется функция, обходящая все childNodes и добавляющая 1 для каждой ноды (nodeType = 1), следующей после <br>
								var startIndex = $(selectedRange.startContainer.parentNode.childNodes).index(selectedRange.startContainer);
								var endIndex = $(selectedRange.endContainer.parentNode.childNodes).index(selectedRange.endContainer);
								startIndex += fixChildNodesCount(selectedRange.startContainer.parentNode, startIndex);
								endIndex += fixChildNodesCount(selectedRange.endContainer.parentNode, endIndex);
							} else {
								var startIndex = $(selectedRange.startContainer.parentNode.childNodes).index(selectedRange.startContainer);
								var endIndex = $(selectedRange.endContainer.parentNode.childNodes).index(selectedRange.endContainer);
							}
							var url =
								startId + ':' + startIndex + ':' + selectedRange.startOffset + ':' +
								endId + ':' + endIndex + ':' + selectedRange.endOffset + ':' + selectedText.length + '!';
							;
							// console.log("#!"+url);
							$.support.cors = true;
							$.blockUI(
							{
								fadeIn: 1000,
								message: commentsBlock,
								css:
								{
									width: 600,
									border: 'none',
									top: ($(window).height()) / 2 + $(window).scrollTop(),
									left: ($(window).width() - commentsBlock.outerWidth(true)) / 2,
									cursor: 'default',
									backgroundColor: '#fff',
									position: 'absolute',
									zIndex: 9999,
									'text-align': 'left'
								},
								overlayCSS:
								{
									cursor:'default'
								},
								onOverlayClick: $.unblockUI,
								onBlock: function () {
									var form = $('#comments-form');

									form
										.find('a.reload').click().end()
										.find('input#COMMENT_URL').val(location.hash.replace(/#?\!.*?\!/, '') ? location.host + location.pathname + location.hash.replace(/#?\!.*?\!/, '') + '!' + url : location.host + location.pathname + '#!' + url).end()
										.find('input#COMMENT_SELECTED_TEXT').val(selectedText).end()
										.find('div.comments-selectedText-text').html(selectedText).end()
										.on('click', 'input#COMMENTS_SEND', function () {
											var button = $(this);
											var arCheckFields	= {};

											form.find('[data-require="true"]').each(function () {
												var field = $(this);
												arCheckFields[field.attr('id')] =
												{
													type: field.data('type'),
													id: 'form#' + form.attr('id') + ' #' + field.attr('id'),
													default: (!empty(field.attr('placeholder')) ? field.attr('placeholder') : '')
												};
												if (field.data('type') == 'captcha') {
													arCheckFields[field.attr('id')].word = field.val();
													arCheckFields[field.attr('id')].sid = form.find('input#captcha_sid').val();
												}
											});

											if (checkFields(arCheckFields) == 0) {
												button.prop('disabled', true);

												var pgwBrowser = $.pgwBrowser();
												var userInfo	=
												{
													browser: {name:pgwBrowser.browser.name, version:pgwBrowser.browser.fullVersion, ua:pgwBrowser.userAgent},
													os: {name:pgwBrowser.os.name, version:pgwBrowser.os.fullVersion},
													pc:
													{
														screenSize: window.screen.width + 'x' + window.screen.height,
														pixelDepth: window.screen.pixelDepth,
														orientation: pgwBrowser.viewport.orientation
													}
												};

												var data =
												{
													sessid: form.find('input#sessid').val(),
													do: form.find('input#do').val(),
													mp_id: form.find('input#COMMENT_MP_ID').val(),
													tags: form.find('input#COMMENT_TAGS').val(),
													author: form.find('input#COMMENT_AUTHOR').val(),
													author_name: form.find('input#COMMENT_AUTHOR_NAME').val(),
													author_lname: form.find('input#COMMENT_AUTHOR_LAST_NAME').val(),
													title: form.find('input#COMMENT_TITLE').val(),
													text: form.find('textarea#COMMENT_TEXT').val(),
													c_text: form.find('input#COMMENT_SELECTED_TEXT').val(),
													url: form.find('input#COMMENT_URL').val(),
													ua: JSON.stringify(userInfo),
													resp: form.find('input#RESPONSIBLE_EMAIL').val()
												};

												var request = $.ajax(
												{
													url: form.find('#AJAX_PATH').val(),
													type: 'POST',
													data: data,
													cache: false,
													crossDomain: false,
													xhr: (window.ActiveXObject) ?
													function () {
															try {
																return new window.ActiveXObject('Microsoft.XMLHTTP');
															} catch (e) {
																console.log('error: ', e);
															}
														} :
														function () {
															return new window.XMLHttpRequest();
														}
												})
												.done(function (data) {

												})
												.always(function (data) {

												})
												.success(function (response)	{
													if (response.result == 'ok')	{
														button.prop('disabled', false);

														form
															.find('input#COMMENT_TITLE').val('').end()
															.find('textarea#COMMENT_TEXT').val('').end()
															.find('div.comments-selectedText-text').html('')
														;

														var popupWindow = $('div#popup-window');

														popupWindow.html(arLangMess[BX.message.LANGUAGE_ID].popupWindow);

														$.blockUI(
														{
															timeout: 2500,
															fadeIn: 1000,
															message: popupWindow,
															css:
															{
																width: 600,
																top: ($(window).height()) / 2 + $(window).scrollTop(),
																left: ($(window).width() - popupWindow.outerWidth(true)) / 2,
																border: 'none',
																cursor: 'default',
																position: 'absolute',
																backgroundColor: '#fff',
																zIndex: 9999,
																'text-align': 'left'
															},
															overlayCSS:
															{
																cursor:'default'
															},
															onUnblock: function () {form.off('click', 'input#COMMENTS_SEND');}
														});
													}
												})
												.fail(function (jqXHR, textStatus, errorThrown) {
													console.log(textStatus, errorThrown);
												});
											}
										})
										.on('click', 'input#COMMENTS_CANCEL', function () {
											$.unblockUI();
											form
												.find('input#COMMENT_TITLE').val('').end()
												.find('textarea#COMMENT_TEXT').val('').end()
												.find('input#captcha_word').val('').end()
												.find('.error-data:not(#COMMENT_AUTHOR)').removeClass('error-data').end()
												.off('click', 'input#COMMENTS_SEND')
											;
										})
									;
								},
								onUnblock: function () {
									$('#comments-form').off('click', 'input#COMMENTS_SEND');
								}
							});
						}
					}
				});
			}
		})(jQuery);

		$('.blockPage__Close').on('click', function (e) {
			$.unblockUI();
			checkedForm
				.find('input#COMMENT_TITLE').val('').end()
				.find('textarea#COMMENT_TEXT').val('').end()
				.find('input#captcha_word').val('').end()
				.find('.error-data:not(#COMMENT_AUTHOR)').removeClass('error-data').end()
				.off('click', 'input#COMMENTS_SEND')
			;
		});

		document.onkeydown = function (e) {
			e = e || window.event;

			if (e.keyCode == 27) {
				$.unblockUI();
			}
		};

		$('body').popline(
		{
			mode: 'view',
			zIndex: 9998
		});

		$('form#comments-form').on('click', 'a.reload', function (e) {
			e.preventDefault();
			$.get('/local/modules/zebra.artools/tools/captcha_code.php', function (data) {
				$('form#comments-form img.captcha-image').attr('src', '/local/modules/zebra.artools/tools/captcha.php?w=180&h=40&captcha_sid=' + data);
				$('form#comments-form input#captcha_sid').val(data);
				$('form#comments-form input#captcha_word').val('');
			});

			return false;
		});

		$(window).on('hashchange',(function () {
			var hash	= location.hash;
			hash = (hash.match(/\!(.*?)\!/) || 'blank');
			if (hash != 'blank') {
				hash = hash[1];
				var arRange = hash.split(':');
				var startNode = arRange[0];
				var startIndex = arRange[1];
				var startOffset = arRange[2];
				var endNode = arRange[3];
				var endIndex = arRange[4];
				var endOffset = arRange[5];
				var selectionSize = arRange[6];
				var range	= document.createRange();
				var s = $('[data-mc-id=' + startNode + ']');
				var e = $('[data-mc-id=' + endNode + ']');
				// ноды в которых находятся начало и конец выделенного текста
				if (!s.length || !e.length) {
					$('<p>Не удается найти отмеченный фрагмент документа.</p>').appendTo(errorBlock);
					errorBlock.fadeIn();
					scrollToPos(errorBlock.offset().top - 10);
					return false;
				}
				if (!browser.msie || (browser.msie && browser.version > 8)) {
					range.setStart(s[0].childNodes[startIndex], startOffset);
					range.setEnd(e[0].childNodes[endIndex], endOffset);
					var sel = window.getSelection();
					sel.removeAllRanges();
					sel.addRange(range);
				} else {
					// IE8
					var range	= new window.Range;
					startIndex -= fixChildNodesCount(s[0], startIndex);
					endIndex -= fixChildNodesCount(e[0], endIndex);
					// вносим поправку на костыль IE8
					range.setStart(s[0].childNodes[startIndex], startOffset);
					range.setEnd(e[0].childNodes[endIndex], endOffset);
					var sel = window.getSelection();
					if (document.selection) {
						document.selection.empty();
					}
					try {
						sel.addRange(range);
					} catch (err) {
						// иногда IE8 валится в диких муках с разнообразными ошибками; ничего для тебя, гори в аду!
					}
					if (Math.abs(sel.toString().replace(/\n/g, '').length - selectionSize) > 20){
						// если размер выделенного текста отличается от исходного больше чем на 20 символов
						// тогда вместо выделения текста ставим маркеры начала и конца выделенного фрагмента
						var startAnchor = s.contents()[startIndex];
						var endAnchor = e.contents()[endIndex];
						var startAnchorText = generateUniqString();
						var endAnchorText = generateUniqString();
						// генерируем уникальные подстроки, чтобы вставить их в начало и конец выделенного текста

						startAnchor.data = startAnchor.data.slice(0, startOffset) + startAnchorText + startAnchor.data.slice(startOffset);
						$(s[0].childNodes[startIndex]).html(startAnchor.data);
						// вставляем иконку начала выделения – как текст
						endAnchor.data = endAnchor.data.slice(0, endOffset) + endAnchorText + endAnchor.data.slice(endOffset);
						$(e[0].childNodes[endIndex]).html(endAnchor.data);
						// вставляем иконку конца выделения – как текст

						var reS = new RegExp(startAnchorText);
						var reE = new RegExp(endAnchorText);
						s.html(s.html().replace(reS, '<span class="zo-start"></span>'));
						e.html(e.html().replace(reE, '<span class="zo-end"></span>'));
						// заменяем уникальные текстовые подстроки на сверстанные маркеры

						document.selection.empty();
						// снимаем косячное выделение
					}

				}
				scrollToPos($('[data-mc-id=' + startNode + ']').offset().top - 10);

			}
		})
	);
	}
});



/** WEBPACK FOOTER **
 ** ./frontend/components/error-report/error-report.js
 **/